import React from "react";
import Countdown from "react-countdown";

function CountDownTimer({ stringDate }) {
  const eventDate: Date = new Date(stringDate);

  return (
    <>
      <Countdown date={eventDate.getTime()} className="countdown-timer" />
    </>
  );
}

export default CountDownTimer;
